<template>
  <section>
    <div class="post-index-header-container">
      <div class="container">
        <div class="grid">
          <div class="g-col-16 g-start-900-2 g-col-900-15">
            <div class="post-index-header">
              <div class="post-index-header-lc">
                <h2 class="h2" v-html="headline"></h2>
                <div class="post-index-header-desc" v-html="description"></div>
              </div>
              <div class="post-index-header-rc">
                <archive-filters
                  :filters="filters"
                  :term="term"
                ></archive-filters>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container post-index-body">
      <div class="grid">
        <div class="g-col-16 g-start-900-2 g-col-900-14">
          <p class="archive-results">{{ foundPosts }}</p>
          <archive-grid
            :posts="posts"
            class_name="post-index-grid archive-grid"
          ></archive-grid>
          <!-- <div class="archive-index-observer"></div> -->

          <div class="post-index-dashboard">
            <button
              class="btn"
              @click="getLoadMorePosts"
              v-if="page < totalpages"
            >
              Load More
            </button>
            <div
              v-if="api_call_status === 1"
              class="post-index-loader label-sm"
            >
              <svg
                version="1.1"
                id="loader-1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="40px"
                height="40px"
                viewBox="0 0 50 50"
                style="enable-background: new 0 0 50 50"
                xml:space="preserve"
              >
                <path
                  fill="#0032ff"
                  d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                  transform="rotate(23.7492 25 25)"
                >
                  <animateTransform
                    attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 25 25"
                    to="360 25 25"
                    dur="0.6s"
                    repeatCount="indefinite"
                  ></animateTransform>
                </path>
              </svg>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, reactive, onMounted } from "vue";
import ArchiveFilters from "./ArchiveFilters.vue";
import ArchiveGrid from "./ArchiveGrid.vue";

export default {
  components: {
    ArchiveFilters,
    ArchiveGrid,
  },
  props: ["searchfor", "taxonomy", "term", "cms"],
  setup(props) {
    let filters = reactive({ list: [] });
    let posts = reactive({ list: [] });
    let search = props.searchfor;
    let taxonomy = props.taxonomy;
    let term = props.term;
    let page = ref(1);
    let totalpages = ref(-1);
    let foundPosts = ref("");
    let headline = ref("");
    let description = ref("");
    let ppp = 40;
    let query;
    // let observerTarget;
    let isLoadCompleted = false;
    let parse_cms;
    let api_call_status = ref(1); //1 = calling api, 0 = done
    let main;

    onMounted(() => {
      main = document.querySelector("main#content");
      main.classList.add("archive-view");
      initialCall();
    });

    /**
     * Initial Call
     */
    const initialCall = () => {
      parse_cms = JSON.parse(props.cms);
      filters.list = parse_cms.filters;

      if(props.searchfor) {
        headline.value = `Search results for ${props.searchfor}`;
      }
    }

    /**
     * Fetch
     */
    function getData(url) {
      return new Promise((resolve, reject) => {
        fetch(url)
          .then((response) => {
            return response.json();
          })
          .then((data) => resolve(data))
          .catch((error) => reject(error));
      });
    }

    const getPosts = (isLoadMore = false) => {
      if (!isLoadMore) {
        page.value = 1;
        isLoadCompleted = false;
      }

      api_call_status.value = 1;

      getData(
        `/wp-json/api/archive-posts/?${query}&ppp=${ppp}&page=${page.value}`
      ).then((data) => {
        // console.log(data.results);
         api_call_status.value = 0;
        totalpages.value = data.results.totalpages;
        foundPosts.value =
          data.results.found_posts < 2
            ? `${data.results.found_posts} RESULT`
            : `${data.results.found_posts} RESULTS`;
        posts.list = isLoadMore
          ? posts.list.concat(data.results.posts)
          : data.results.posts;

        // console.log(data.results);



      if(props.searchfor) {
        headline.value = `Search results for ${props.searchfor}`;
        // description.value = `<p>${foundPosts.value}</p>`;
        description.value = '';
      } else {
        headline.value = data.results.term_name;
        description.value = `<p>${data.results.term_description}</p>`;
      }

      });
    };

    /**
     * Initial call: get posts
     */
    if (taxonomy && term) {
      query = `taxonomy=${taxonomy}&term=${term}`;
    } else if (search) {
      query = `searchfor=${search}`;
    }

    getPosts(false);

    /**
     * get posts by load more button
     */
    const getLoadMorePosts = () => {
      page.value++;

      if (page.value <= totalpages.value) {
        getPosts(true);
      } else {
        isLoadCompleted = true;
      }
    };

    return {
      filters,
      term,
      posts,
      page,
      headline,
      description,
      foundPosts,
      totalpages,
      api_call_status,
      getLoadMorePosts,
    };
  },
};
</script>
